// @flow

/**
 * Module dependencies.
 */

import { getNumbers } from './forms';

/**
 * Export `formatAmount`.
 */

export function formatAmount(
  value: number | string,
  prefix: string,
  thousandSeparator: string
): string {
  const strippedValue = getNumbers(value);
  const dividedValues = strippedValue.split(/(?=(?:...)*$)/);
  const formatedValue = dividedValues.join(thousandSeparator);

  return `${prefix}${formatedValue}`;
}



// WEBPACK FOOTER //
// ../src/client/core/utils/formatter.js